import React, {useState} from 'react';
import {defaultProject, defaultUser, DraftProjectContext, ProjectContext, UserContext} from 'services/contexts';
import {IUser} from "models/auth";
import {IProject} from "../models/project";

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const [user, setUser] = useState<IUser>(defaultUser);
    return <UserContext.Provider value={{user, setUser}}>{children}</UserContext.Provider>;
};


export const ProjectProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const [selectedProject, setSelectedProject] = useState<IProject>(defaultProject);
    return <ProjectContext.Provider value={{selectedProject, setSelectedProject}}>{children}</ProjectContext.Provider>;
};

export const DraftProjectProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const [draftProject, setDraftProject] = useState<IProject>(defaultProject);
    return <DraftProjectContext.Provider value={{draftProject, setDraftProject}}>{children}</DraftProjectContext.Provider>;
};